import { render, staticRenderFns } from "./Bmap.vue?vue&type=template&id=f98004ea&"
import script from "./Bmap.vue?vue&type=script&lang=js&"
export * from "./Bmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports